import React, { useState } from "react";
import CustomSvg from "../svgs/CustomSvg";
import { styled } from '@mui/material/styles';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#1890ff',
        ...(theme.applyStyles ? theme.applyStyles('dark', { backgroundColor: '#177ddc' }) : {}),
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
    ...(theme.applyStyles ? theme.applyStyles('dark', { backgroundColor: 'rgba(255,255,255,.35)' }) : {}),
  },
}));

export default function Security() {
  const [faceId, setFaceId] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);
  const [touchId, setTouchId] = useState(false);

  return (
    <div className="min-h-screen bg-[#130828] flex flex-col items-center  pb-8 px-4">
      <h2 className="text-white text-2xl font-bold mb-8">Security</h2>
      <div className="w-full max-w-md bg-[#1E1B2E] rounded-2xl p-6 shadow-lg">
        <FormGroup>
          <FormControlLabel
            control={<AntSwitch checked={faceId} onChange={() => setFaceId(v => !v)} />}
            label={<span className="text-white text-base font-medium">Face ID</span>}
            className="flex justify-between mb-4"
            labelPlacement="start"
          />
          <FormControlLabel
            control={<AntSwitch checked={rememberMe} onChange={() => setRememberMe(v => !v)} />}
            label={<span className="text-white text-base font-medium">Remember me</span>}
            className="flex justify-between mb-4"
            labelPlacement="start"
          />
          <FormControlLabel
            control={<AntSwitch checked={touchId} onChange={() => setTouchId(v => !v)} />}
            label={<span className="text-white text-base font-medium">Touch ID</span>}
            className="flex justify-between"
            labelPlacement="start"
          />
        </FormGroup>
      </div>
    </div>
  );
}